import { useEffect, useRef, useState } from 'react';

import { ForwardBanner, ForwardRequestModal } from '#/features/request-forwarding';
import { Container } from '#/shared/components/layout/Container';
import { useAccessToken } from '#/shared/hooks/useAccessToken';
import { useFeatureFlag } from '#/shared/hooks/useFeatureFlag';
import { usePageStateStore } from '#/shared/stores/pageStateStore';
import { useTimesheetActionViewStore } from '#/shared/stores/timesheetActionViewStore';

import { TimesheetActionsContainer } from './TimesheetActionsContainer';
import { TimesheetReviewContainer } from './TimesheetReviewContainer';

export function TimesheetReviewScreen() {
  const token = useAccessToken();
  const pageState = usePageStateStore(state => state.pageState);
  const actionsContainerRef = useRef<HTMLDivElement>(null);
  const setActionsContainerRef = usePageStateStore(state => state.setActionsContainerRef);

  const setView = useTimesheetActionViewStore(state => state.setView);

  // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this useFeatureFlag, useState and handleForwardRequest
  const { isEnabled: timesheetActionsSelectionIsEnabled } = useFeatureFlag('PPL-2239-timesheet-actions-selection');
  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);

  useEffect(() => {
    setActionsContainerRef(actionsContainerRef);
    return () => setActionsContainerRef(null);
  }, [setActionsContainerRef]);

  const handleForwardRequest = () => {
    // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this feature flag check and return statement
    if (timesheetActionsSelectionIsEnabled) {
      actionsContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setView('forward');
      return;
    }
    // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove the setIsForwardModalOpen logic
    setIsForwardModalOpen(true);
  };

  // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this useEffect
  useEffect(() => {
    if (timesheetActionsSelectionIsEnabled) {
      return;
    }
    if (!token || pageState !== 'loading-success') {
      // eslint-disable-next-line
      setIsForwardModalOpen(false);
      return;
    }
    if (window.location.search.includes('forward=true')) {
      setIsForwardModalOpen(true);
    }
  }, [token, pageState, timesheetActionsSelectionIsEnabled]);

  // TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this bannerElement
  const bannerElement = <ForwardBanner onForwardRequest={handleForwardRequest} />;

  return (
    <Container className="flex-1 px-md">
      <div className="block tablet-portrait:hidden pt-16">{bannerElement}</div>
      <div className="-mx-md tablet-portrait:mx-0">
        <div className="flex-1 w-full grid grid-cols-1 tablet-portrait:grid-cols-2 desktop-small:grid-cols-3 tablet-portrait:gap-md">
          <div className="col-span-1 tablet-portrait:col-span-1 desktop-small:col-span-2">
            <TimesheetReviewContainer />
          </div>
          <div className="col-span-1 tablet-portrait:col-span-1 desktop-small:col-span-1">
            <TimesheetActionsContainer bannerElement={bannerElement} actionsContainerRef={actionsContainerRef} />
          </div>
        </div>
      </div>
      {/* TODO: PPL-2239-timesheet-actions-selection cleanup - Remove this modal */}
      <ForwardRequestModal isOpen={isForwardModalOpen} onClose={() => setIsForwardModalOpen(false)} />
    </Container>
  );
}
